import { useTranslations } from "next-intl";
import { El_Messiri, Josefin_Sans } from "next/font/google";

import AccordionV2 from "@/components/Accordion/AccordionV2";
import Icon from "@/components/ui/Icon/Icon";
import { FaqBoxItem, FaqBoxProps } from "@/types";

import RichText from "../RichText/RichText";

const elMessiri = El_Messiri({ subsets: ["latin"] });
const josefin = Josefin_Sans({ subsets: ["latin"] });

export default function FaqBox({ entry, isInventoryVairant }: FaqBoxProps) {
  const closedIcon = <Icon size="24" name="chevron-down" title="open" className="stroke-black" />;
  const openIcon = <Icon size="24" name="chevron-up" title="close" className="stroke-black" />;
  const t = useTranslations();
  let overrideAccentFont = "";

  if (entry?.primaryFont && entry.primaryFont != "Termina") {
    switch (entry.primaryFont) {
      case "El Messiri":
        overrideAccentFont = elMessiri.style.fontFamily;
        break;
      case "Josefin Sans":
        overrideAccentFont = josefin.style.fontFamily;
        break;
    }
  }

  return (
    <div
      className="w-full"
      style={
        {
          backgroundColor: entry.backgroundColor ?? undefined,
        } as React.CSSProperties
      }
    >
      <div className="w-22\/24 md:w-20\/24 mx-auto">
        {/* font termina */}
        <div className={`mx-auto  py-3xl  ${entry.isHighlight ? "shadow-strong rounded-lg md:rounded-2xl p-l" : ""}`}>
          {isInventoryVairant && (
            <div
              className="font-primary-override-container-faq pt-m"
              style={
                {
                  "--font-primary-override": overrideAccentFont,
                  color: entry.primaryColor,
                  "--font-accent-color": entry.accentColor,
                  "--font-primary-color": entry.primaryColor,
                } as React.CSSProperties
              }
            >
              {entry.overtitle && <div className="uppercase pb-xs text-xs text-black">{entry.overtitle}</div>}
              <div className="uppercase pb-m pt-xs text-xl accent-title accent-color">
                {entry?.title ? entry?.typeIndex == 1 ? <h1>{entry?.title}</h1> : entry?.title : t("title.common.faq")}
              </div>
            </div>
          )}
          <div className="flex flex-col text-black-0 pb-m">
            {entry.icon && (
              <div className="flex items-center gap-m mb-l">
                <Icon className="stroke-black" name={entry.icon?.link?.icon ?? ""} size="40" title="Alternative text" />
                <div>
                  <h3 className="font-primary font-medium uppercase leading-4 tracking-widest pb-xs">{t(entry.title)}</h3>
                  <p className="text-s">{entry.subTitle}</p>
                </div>
              </div>
            )}
            {entry.items?.map((item: FaqBoxItem, index: number, items) => (
              <AccordionV2
                key={`qa-accordion-${index}`}
                title={<div className="flex flex-row py-s font-secondary font-normal text-m leading-6">{t(item.question)}</div>}
                content={<RichText content={item.answer} />}
                defaultOpen={false}
                openIcon={openIcon}
                closedIcon={closedIcon}
                customClassName={`text-black-0 ${entry.isHighlight && items.length - 1 === index ? "border-0" : "border-b border-gray-10"}`}
                customClassNameOpen="border-transparent"
                cta={item.cta}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
